import { MailLockEntryDTO } from 'src/app/shared/interfaces';

export class GetAllMailsLockedParams {
  /* Available values : Read, Write. Nothing will take all mails */
  mode?: string;

  contactIds?: number[];
  courrierIds?: number[];
  sortFields?: string;
  sortOrder?: string;
  pageNumber?: number;
  pageSize?: number;
}

export class MailLockEntry {
  id: string;
  version: number;
  mode: number;
  lockMode: string;
  date: string;
  source: string;
  contactId: number;
  courrierId: number;
  courrier: {
    id: number;
    objet: string;
  };
  name?: string;
  constructor(data: MailLockEntryDTO) {
    Object.assign(this, data);
  }
}

export class MailLocks {
  id: string;
  version: number;
  mode: number;
  lockMode: string;
  date: string;
  source: string;
  contactId: number;
  courrierId: number;
  courrier: {
    id: number;
    objet: string;
  };
  contactName?: string;

  constructor(data: MailLockEntryDTO) {
    Object.assign(this, data);
  }
}
